import ScalarIconBookOpen_vue_vue_type_script_setup_true_lang_default from "./ScalarIconBookOpen.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconBookOpen.vue
var ScalarIconBookOpen_default = ScalarIconBookOpen_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconBookOpen_default as default };

//# sourceMappingURL=ScalarIconBookOpen.js.map